export type LocationMenuItem = { name: string; url: string };
export type LocationMenuState = LocationMenuItem & { cities: LocationMenuItem[] };

export const locationMenuStates: LocationMenuState[] = [
  { name: "Arizona", url: "/lawyer-seo/arizona-seo", cities: [
    { name: "Phoenix", url: "/lawyer-seo/phoenix-seo" },
    { name: "Tucson", url: "/lawyer-seo/tucson-seo" },
    { name: "Scottsdale", url: "/lawyer-seo/scottsdale-seo" },
  ] },
  { name: "Arkansas", url: "/lawyer-seo/arkansas-seo", cities: [] },
  { name: "California", url: "", cities: [
    { name: "Los Angeles", url: "/lawyer-seo/los-angeles-seo" },
    { name: "San Francisco", url: "/lawyer-seo/san-francisco-seo" },
    { name: "San Diego", url: "/lawyer-seo/san-diego-seo" },
    { name: "Sacramento", url: "/lawyer-seo/sacramento-seo" },
    { name: "Santa Ana", url: "/lawyer-seo/santa-ana-seo" },
    { name: "Ventura County", url: "/lawyer-seo/ventura-county-seo" },
    { name: "San Bernardino", url: "/lawyer-seo/san-bernardino-seo" },
    { name: "Fresno", url: "/lawyer-seo/fresno-seo" },
    { name: "Stockton", url: "/lawyer-seo/stockton-seo" },
  ] },
  { name: "Colorado", url: "", cities: [{ name: "Denver", url: "/lawyer-seo/denver-seo" }] },
  { name: "Connecticut", url: "/lawyer-seo/connecticut-seo", cities: [] },
  { name: "Delaware", url: "/lawyer-seo/delaware-seo", cities: [] },
  { name: "Florida", url: "/lawyer-seo/florida-seo", cities: [
    { name: "Miami", url: "/lawyer-seo/miami-seo" },
    { name: "Jacksonville", url: "/lawyer-seo/jacksonville-seo" },
    { name: "Orlando", url: "/lawyer-seo/orlando-seo" },
    { name: "Tampa", url: "/lawyer-seo/tampa-seo" },
  ] },
  { name: "Georgia", url: "/lawyer-seo/georgia-seo", cities: [{ name: "Atlanta", url: "/lawyer-seo/atlanta-seo" }] },
  { name: "Illinois", url: "/lawyer-seo/illinois-seo", cities: [
    { name: "Chicago", url: "/lawyer-seo/chicago-seo" },
    { name: "Peoria", url: "/lawyer-seo/peoria-seo" },
  ] },
  { name: "Indiana", url: "/lawyer-seo/indiana-seo", cities: [] },
  { name: "Iowa", url: "/lawyer-seo/iowa-seo", cities: [] },
  { name: "Kansas", url: "/lawyer-seo/kansas-seo", cities: [] },
  { name: "Louisiana", url: "/lawyer-seo/louisiana-seo", cities: [] },
  { name: "Maryland", url: "/lawyer-seo/maryland-seo", cities: [{ name: "Baltimore", url: "/lawyer-seo/baltimore-seo" }] },
  { name: "Massachusetts", url: "", cities: [{ name: "Boston", url: "/lawyer-seo/boston-seo" }] },
  { name: "Michigan", url: "/lawyer-seo/michigan-seo", cities: [] },
  { name: "Minnesota", url: "/lawyer-seo/minnesota-seo", cities: [{ name: "Minneapolis", url: "/lawyer-seo/minneapolis-seo" }] },
  { name: "Missouri", url: "", cities: [{ name: "Kansas City", url: "/lawyer-seo/kansas-city-seo" }] },
  { name: "Montana", url: "/lawyer-seo/montana-seo", cities: [] },
  { name: "Nevada", url: "/lawyer-seo/nevada-seo", cities: [{ name: "Las Vegas", url: "/lawyer-seo/las-vegas-seo" }] },
  { name: "New Hampshire", url: "/lawyer-seo/new-hampshire-seo", cities: [] },
  { name: "New Mexico", url: "/lawyer-seo/new-mexico-seo", cities: [] },
  { name: "New York", url: "/lawyer-seo/new-york-seo", cities: [{ name: "Long Island", url: "/lawyer-seo/long-island-seo" }] },
  { name: "North Carolina", url: "/lawyer-seo/north-carolina-seo", cities: [{ name: "Charlotte", url: "/lawyer-seo/charlotte-seo" }] },
  { name: "North Dakota", url: "/lawyer-seo/north-dakota-seo", cities: [] },
  { name: "Ohio", url: "/lawyer-seo/ohio-seo", cities: [{ name: "Cleveland", url: "/lawyer-seo/cleveland-seo" }] },
  { name: "Oklahoma", url: "", cities: [{ name: "Tulsa", url: "/lawyer-seo/tulsa-seo" }] },
  { name: "Oregon", url: "", cities: [{ name: "Portland", url: "/lawyer-seo/portland-seo" }] },
  { name: "Pennsylvania", url: "/lawyer-seo/pennsylvania-seo", cities: [{ name: "Philadelphia", url: "/lawyer-seo/philadelphia-seo" }] },
  { name: "South Carolina", url: "/lawyer-seo/south-carolina-seo", cities: [] },
  { name: "Tennessee", url: "/lawyer-seo/tennessee-seo", cities: [{ name: "Nashville", url: "/lawyer-seo/nashville-seo" }] },
  { name: "Texas", url: "/lawyer-seo/texas-seo", cities: [
    { name: "Houston", url: "/lawyer-seo/houston-seo" },
    { name: "Dallas", url: "/lawyer-seo/dallas-seo" },
    { name: "Austin", url: "/lawyer-seo/austin-seo" },
    { name: "San Antonio", url: "/lawyer-seo/san-antonio-seo" },
  ] },
  { name: "Vermont", url: "/lawyer-seo/vermont-seo", cities: [] },
  { name: "Virginia", url: "/lawyer-seo/virginia-seo", cities: [] },
  { name: "Washington", url: "", cities: [{ name: "Seattle", url: "/lawyer-seo/seattle-seo" }] },
  { name: "Washington DC", url: "/lawyer-seo/washington-dc-seo", cities: [] },
  { name: "West Virginia", url: "/lawyer-seo/west-virginia-seo", cities: [] },
  { name: "Wisconsin", url: "/lawyer-seo/wisconsin-seo", cities: [] },
  { name: "Wyoming", url: "/lawyer-seo/wyoming-seo", cities: [] },
];